import { get } from 'lodash';

import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';

const reduceSalons = (state, data) => ({
  ...state,
  supportSalons: fromEntriesToObject((get(data, 'response.support') || []).map(({ id }) => [String(id), true])),
});

// noinspection JSUnusedGlobalSymbols
export default reduceSalons;
